import { Layout } from 'components/layout';
import React from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '../carousel/carousel';

export const AdvantagesCarousel = () => {
  return (
    <div>
      <Layout.Container>
        <div className="relative">
          <Carousel>
            <CarouselContent className='cursor-move'>
              <CarouselItem>
                <img
                  src="/assets/images/png/about.jpg"
                  alt="carousel-image"
                  className="rounded-[20px] screen-900:rounded-none"
                />
              </CarouselItem>
              <CarouselItem>
                <img
                  src="/assets/images/png/main.jpg"
                  alt="carousel-image"
                  className="rounded-[20px] screen-900:rounded-none"
                />
              </CarouselItem>
              <CarouselItem>
                <img
                  src="/assets/images/png/2.jpg"
                  alt="carousel-image"
                  className="rounded-[20px] screen-900:rounded-none"
                />
              </CarouselItem>
              <CarouselItem>
                <img
                  src="/assets/images/png/5.jpg"
                  alt="carousel-image"
                  className="rounded-[20px] screen-900:rounded-none"
                />
              </CarouselItem>
              <CarouselItem>
                <img
                  src="/assets/images/png/4.jpg"
                  alt="carousel-image"
                  className="rounded-[20px] screen-900:rounded-none"
                />
              </CarouselItem>
            </CarouselContent>
            <div className="absolute top-[49px] left-[33px] flex items-center gap-4 screen-900:hidden">
              <CarouselPrevious className="absolute top-0 left-0 border-plt-secondary border-[2px] bg-plt-secondary" />
              <CarouselNext className="absolute top-0 left-[40px] border-plt-secondary border-[2px] bg-plt-secondary" />
            </div>
            <div className="hidden screen-900:flex justify-center items-center gap-2 mt-10">
              <CarouselPrevious className="static size-[56px] top-0 border-plt-secondary border-2 bg-plt-secondary" />
              <CarouselNext className="static size-[56px] top-0 border-plt-secondary border-2 bg-plt-secondary" />
            </div>
          </Carousel>
        </div>
      </Layout.Container>
    </div>
  );
};
